import {UploadServices} from "store";

export const fileUpload = (file) => {
    const name = file?.name?.replace(',', '').replace(/\s/g, '').replace('#', '');
    const myNewFile = new File([file], name, {type: file?.type});
    const formData = new FormData();
    formData.append('files', myNewFile);
    return formData;
}


// export const fileUpload = async (file) => {
//     const name = file?.name?.replace(',', '').replace(/\s/g, '').replace('#', '');
//     const myNewFile = new File([file], name, { type: file?.type });
//     const formData = new FormData();
//     formData.append('files', myNewFile);
//     return await UploadServices.UploadImage(formData);
// }